import type { SegmentShareEvent } from 'src/common/types';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useTrackEventMutation } from 'src/common/slices';
import { StyledSocialButton } from 'src/common/styles';
import { Achievement, SocialName, type SocialLinks } from 'src/common/page-share/page-share.types';
import { socialTrackEvents } from 'src/common/page-share/page-share.constants';
import { useSocialLinks } from 'src/common/page-share/use-social-links';
import { BadgeModalSocialShareStyledWrapperButtons } from './badge-modal-social-share.styles';
export interface BadgeShareModalSocialSharingProps {
  username: string;
  badgeName: string;
  socialLinks: SocialLinks;
}
export const BadgeShareModalSocialSharing = ({
  username,
  badgeName,
  socialLinks = {
    [SocialName.twitter]: true,
    [SocialName.facebook]: true,
    [SocialName.linkedin]: true
  }
}: BadgeShareModalSocialSharingProps) => {
  const filteredLinks = useSocialLinks(socialLinks);
  const leagueUrl = `https://tryhackme.com/${username}/badges/${badgeName}`;
  const [trackEvent] = useTrackEventMutation();
  const location = useLocation();
  const trackShareClick = useCallback((event: SegmentShareEvent) => {
    const source = event.split('-')[1];
    // eslint-disable-next-line no-void
    void trackEvent({
      event: 'social-share',
      properties: {
        page: location.pathname,
        achievement: Achievement.badge,
        medium: source,
        clicked_on: source,
        name: 'badge-share'
      }
    });
  }, [trackEvent, location.pathname]);
  return <BadgeModalSocialShareStyledWrapperButtons data-sentry-element="BadgeModalSocialShareStyledWrapperButtons" data-sentry-component="BadgeShareModalSocialSharing" data-sentry-source-file="badge-modal-social-share.tsx">
      {filteredLinks.map(social => <StyledSocialButton key={social.name} data-social={social.name} href={social.href({
      description: 'Share your badge',
      url: leagueUrl,
      campaign: {
        utmContent: 'badge'
      }
    })} target="_blank" onClick={() => trackShareClick(socialTrackEvents[social.name])}>
          <social.icon />
          {social.officialName}
        </StyledSocialButton>)}
    </BadgeModalSocialShareStyledWrapperButtons>;
};